// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrdenesPedido_container__K9K3C {
  animation: OrdenesPedido_init__wNpxZ 1s;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

/*--Header--*/
.OrdenesPedido_container__K9K3C .OrdenesPedido_header__gf0xF {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.OrdenesPedido_container__K9K3C .OrdenesPedido_header__gf0xF .OrdenesPedido_titleContainer__ISAeI {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.OrdenesPedido_container__K9K3C .OrdenesPedido_header__gf0xF .OrdenesPedido_titleContainer__ISAeI h4 {
  text-align: center;
  font-size: 1.6rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin-left: 10px;
}

.OrdenesPedido_container__K9K3C .OrdenesPedido_header__gf0xF .OrdenesPedido_titleContainer__ISAeI .OrdenesPedido_add_btn__-abNo {
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2.5rem;
  width: 6.5rem;
  text-transform: capitalize;
  border-radius: 5px;
  font-size: 1rem;
  font-weight: 300;
  font-family: Roboto, sans-serif;
  margin-left: 10px;
}

.OrdenesPedido_container__K9K3C .OrdenesPedido_filters__DQWc1 {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.OrdenesPedido_container__K9K3C .OrdenesPedido_filters__DQWc1 .OrdenesPedido_filterButton__uHh22 {
  text-transform: capitalize;
  height: 3rem;
  width: 10rem;
  margin-left: 5px;
  margin-bottom: 10px;
  border-radius: 5px;
}

.OrdenesPedido_container__K9K3C .OrdenesPedido_header__gf0xF .OrdenesPedido_filters__DQWc1 .OrdenesPedido_filterButton__uHh22 p {
  font-size: 0.9rem;
  margin-left: 5px;
  font-weight: 400;
}

.OrdenesPedido_container__K9K3C .OrdenesPedido_noResults__oaTpB {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 1.5rem;
  font-weight: 300;
  height: 300px;
}

/*---Información---*/
.OrdenesPedido_container__K9K3C .OrdenesPedido_data__AnWZT .OrdenesPedido_tableContainer__1f4vi {
  border-radius: 10px;
  max-height: 80vh;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.OrdenesPedido_container__K9K3C .OrdenesPedido_data__AnWZT .OrdenesPedido_tableContainer__1f4vi .OrdenesPedido_iconbtn__0igMo {
  transition: 0.3s;
  font-size: 1.8rem;
}

.OrdenesPedido_container__K9K3C .OrdenesPedido_data__AnWZT .OrdenesPedido_tableContainer__1f4vi .OrdenesPedido_iconbtn__0igMo:hover {
  transition: 0.3s;
  cursor: pointer;
  filter: brightness(0.7);
  scale: 1.1;
}

.OrdenesPedido_container__K9K3C .OrdenesPedido_data__AnWZT .OrdenesPedido_pagination__SxYNt {
  margin-top: 50px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.OrdenesPedido_container__K9K3C .OrdenesPedido_loader__bHhO3 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}

@keyframes OrdenesPedido_init__wNpxZ {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@media screen and (max-width: 500px) {
  .OrdenesPedido_container__K9K3C .OrdenesPedido_header__gf0xF .OrdenesPedido_titleContainer__ISAeI .OrdenesPedido_add_btn__-abNo {
    width: 80px;
    height: 40px;
  }
  .OrdenesPedido_container__K9K3C .OrdenesPedido_header__gf0xF .OrdenesPedido_titleContainer__ISAeI h4 {
    font-size: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/OrdenesPedido/OrdenesPedido.module.css"],"names":[],"mappings":"AAAA;EACE,uCAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".container {\n  animation: init 1s;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n/*--Header--*/\n.container .header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.container .header .titleContainer {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  text-align: center;\n  font-size: 1.6rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin-left: 10px;\n}\n\n.container .header .titleContainer .add_btn {\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 2.5rem;\n  width: 6.5rem;\n  text-transform: capitalize;\n  border-radius: 5px;\n  font-size: 1rem;\n  font-weight: 300;\n  font-family: Roboto, sans-serif;\n  margin-left: 10px;\n}\n\n.container .filters {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.container .filters .filterButton {\n  text-transform: capitalize;\n  height: 3rem;\n  width: 10rem;\n  margin-left: 5px;\n  margin-bottom: 10px;\n  border-radius: 5px;\n}\n\n.container .header .filters .filterButton p {\n  font-size: 0.9rem;\n  margin-left: 5px;\n  font-weight: 400;\n}\n\n.container .noResults {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-size: 1.5rem;\n  font-weight: 300;\n  height: 300px;\n}\n\n/*---Información---*/\n.container .data .tableContainer {\n  border-radius: 10px;\n  max-height: 80vh;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .data .tableContainer .iconbtn {\n  transition: 0.3s;\n  font-size: 1.8rem;\n}\n\n.container .data .tableContainer .iconbtn:hover {\n  transition: 0.3s;\n  cursor: pointer;\n  filter: brightness(0.7);\n  scale: 1.1;\n}\n\n.container .data .pagination {\n  margin-top: 50px;\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n}\n\n.container .loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .container .header .titleContainer .add_btn {\n    width: 80px;\n    height: 40px;\n  }\n  .container .header .titleContainer h4 {\n    font-size: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `OrdenesPedido_container__K9K3C`,
	"init": `OrdenesPedido_init__wNpxZ`,
	"header": `OrdenesPedido_header__gf0xF`,
	"titleContainer": `OrdenesPedido_titleContainer__ISAeI`,
	"add_btn": `OrdenesPedido_add_btn__-abNo`,
	"filters": `OrdenesPedido_filters__DQWc1`,
	"filterButton": `OrdenesPedido_filterButton__uHh22`,
	"noResults": `OrdenesPedido_noResults__oaTpB`,
	"data": `OrdenesPedido_data__AnWZT`,
	"tableContainer": `OrdenesPedido_tableContainer__1f4vi`,
	"iconbtn": `OrdenesPedido_iconbtn__0igMo`,
	"pagination": `OrdenesPedido_pagination__SxYNt`,
	"loader": `OrdenesPedido_loader__bHhO3`
};
export default ___CSS_LOADER_EXPORT___;
